import FolderOpenOutlined from '@mui/icons-material/FolderOpenOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

export const DevicesAndGroupsColumnHeader: React.FC = () => {
  const { translation } = useTranslation();
  return (
    <ColumnHeaderWithTooltip
      label={translation.device_groups_column_header}
      tooltip={
        <Stack spacing={1}>
          <Typography variant="caption">{translation.devices_not_double_counted_tooltip}</Typography>
          <Stack spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <LockOutlined fontSize="extraSmall" />
              <Typography variant="caption">{translation.individual_device}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <FolderOpenOutlined fontSize="extraSmall" />
              <Typography variant="caption">{translation.device_group}</Typography>
            </Stack>
          </Stack>
        </Stack>
      }
    />
  );
};
